import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlannerAppointmentConflicts } from '~constants/api';

import { Paginated, Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { Row } from '~libs/reduxUtils';

import { typePrefix as prefix } from '~weekly-planner/actions/appointments';

export const typePrefix = `${prefix}-conflicts`;

export const conflictsApi = createApi({
  reducerPath: 'weeklyPlannerConflictsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlannerAppointmentConflicts }),
  tagTypes: ['conflicts'],
  endpoints: (builder) => ({
    getConflicts: builder.query<Paginated<Row>, Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'conflicts', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Paginated<Row>>(payload),
    }),
  }),
});

export const { useGetConflictsQuery } = conflictsApi;
